module.exports = __webpack_public_path__ + "static/media/tableBook.00fdcf6a.svg";